import Dropzone from "dropzone";
import {DirectUpload} from "activestorage"
import $ from 'jquery';

class ActiveStorageDropzoneNew {
    constructor(dropzoneClass, uploaderClass) {
        this.DropzoneClass = dropzoneClass || Dropzone
        this.UploaderClass = uploaderClass || DirectUpload
    }

    init(element) {
        var acceptedFiles = $(element).data("accepted-files") || "image/*";
        var dictDefaultMessage = $(element).data("placeholder") || "Drop files here";
        var submitButton = $($(element).data("submit-button"));
        var maxFileSize = $(element).data("max-file-size");
        var that = this;

        this.myDropzone = new this.DropzoneClass(element, {
            url: "/",
            autoQueue: true,
            autoDiscover: false,
            acceptedFiles: acceptedFiles,
            parallelUploads: 50,
            dictDefaultMessage: dictDefaultMessage,
            maxFilesize: maxFileSize,
            addRemoveLinks: true,
            // clickable: false,

            init: function () {
                this.on("sending", (file, xhr, formData) => {
                    var createUpload = (dropzone, upload) => {
                        upload.create((error, blob) => {
                            if (error) {
                                dropzone.emit("error", file, this.options.dictUploadCanceled);
                            } else {
                                const hiddenField = document.createElement('input');
                                hiddenField.setAttribute("type", "hidden");
                                hiddenField.setAttribute("value", blob.signed_id);
                                hiddenField.name = name;
                                document.querySelector('form').appendChild(hiddenField);
                                file.signed_id = blob.signed_id; // assign to file to identify deleted file without submitting the form.
                                dropzone.emit("success", file);
                                dropzone.emit("complete", file);
                            }

                            // In either case, re-enable the provided submit button
                            if (submitButton) {
                                submitButton.prop("disabled", false);
                            }
                        });
                    }
                    // Disable any provided submit button
                    if (submitButton) {
                        submitButton.prop("disabled", true);
                    }

                    // Cancel the default server request
                    xhr.addEventListener("loadstart", () => {
                        xhr.abort();
                    });

                    // Start the direct upload
                    const input = getFileInput();
                    const name = input.name;
                    const url = input.dataset.directUploadUrl;
                    const delegate = {
                        directUploadWillStoreFileWithXHR: (request) => {
                            request.upload.addEventListener("progress", (event) => {
                                this.emit("uploadprogress", file, 100 * (event.loaded / (event.total || event.totalSize)), event.loaded);
                            });
                        }
                    }
                    const upload = new that.UploaderClass(file, url, delegate);
                    createUpload(this, upload);
                });
            },
        });

        this.myDropzone.on("addedfile", function (file) {
            // Show download link in dropzone previews
            if (typeof file.dataURL !== "undefined") {
                let div = document.createElement("div");
                let anchor = document.createElement("a");
                anchor.innerHTML = "<i class='fa fa-download' aria-hidden='true'></i> Download";
                anchor.href = file.dataURL;
                anchor.setAttribute('target', '_blank');
                anchor.setAttribute('style', 'background-color: rgba(255, 255, 255, 0.4); padding: 0 0.4em; border: 1px solid transparent; text-decoration: none;');

                // Added expand option
                let anchor2 = document.createElement("a");
                anchor2.innerHTML = "<i class='fa fa-expand' aria-hidden='true'></i>";
                // anchor2.href = "javascript:window.open('" + file.dataURL + "','mypopuptitle', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" +w+ ", height=" +h+ ", top=" +tops+ ", left=" +left+ "')";
                anchor2.onclick = function(){
                    popupwindow(file.dataURL ,'mypopuptitle',800, 600)
                }
                anchor2.setAttribute('title', 'Expand');
                anchor2.setAttribute('style', 'background-color: rgba(255, 255, 255, 0.9);padding: 5px 10px; border: 1px solid #d3d3d3; position: absolute;top: -5px;right: -5px;cursor: pointer;');

                div.append(anchor);
                div.append(anchor2);
                div.setAttribute('class', 'dz-download-link')
                div.setAttribute('style', 'margin-top: 1em;')
                $(file.previewElement.childNodes[3]).append(div);
            }
        });

        this.myDropzone.on("removedfile", function (file) {
            if (file.fileId === null) {
                // If user remove the file before submitting the form, we need to remove input tag under form at the time of validation failed.
                if (typeof file.dataURL === 'string') {
                    let selectedTag = null;
                    $('input[type=hidden]').each(function (index, tag) {
                        if (tag.value && typeof tag.value === 'string' && tag.value.length > 10 && file.dataURL.includes(tag.value)) {
                            selectedTag = tag;
                            // console.log(index, file.dataURL.includes(tag.value), tag.value)
                        }
                    });
                    if (selectedTag !== null) {
                        $(selectedTag).remove();
                    }
                }
            } else if (typeof file.fileId !== "undefined") {
                if (confirm("Are you sure you want to remove this file?")) {
                    // Once user confirm delete request of file, It will store as hidden input val
                    const hiddenField = document.createElement('input');
                    hiddenField.setAttribute("type", "hidden");
                    hiddenField.setAttribute("value", file.fileId);
                    hiddenField.name = getFileInputName(true);
                    document.querySelector('form').appendChild(hiddenField);
                } else {
                    // When user click on already uploaded file it will direct trigger remove event of dropzone and so we need to display it again.
                    addFileToDropZone(that.myDropzone, file);
                }
            } else if (typeof file.signed_id !== "undefined") {
                // If user remove the file before submitting the form, we need to remove input tag under form
                if (typeof file.signed_id === 'string') {
                    let selectedTag = null;
                    $('input[type=hidden]').each(function (index, tag) {
                        // console.log(index, file.signed_id.includes(tag.value), tag.value)
                        if (tag.value && typeof tag.value === 'string' && tag.value.length > 10 && file.signed_id.includes(tag.value)) {
                            selectedTag = tag;
                        }
                    });
                    if (selectedTag !== null) {
                        $(selectedTag).remove();
                    }
                }
            }

        });

        const popupwindow = (url, title, w, h) => {
            var y = window.outerHeight / 2 + window.screenY - ( h / 2)
            var x = window.outerWidth / 2 + window.screenX - ( w / 2)
            return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + y + ', left=' + x);
        }

        const getFileInputName = (isItForRemovedFile) =>
            isItForRemovedFile
                ? getFileInput().name.replace("files", "rm_files").replace("photos", "rm_photos")
                : getFileInput().name;

        const getFileInput = () =>
            document.getElementById(element.dataset.fileInputId);

        const addFileToDropZone = (dropzone, file, index) => {
            dropzone.emit("addedfile", file);
            if (file.type.indexOf("image") >= 0) {
                dropzone.createThumbnailFromUrl(
                    file,
                    dropzone.options.thumbnailWidth,
                    dropzone.options.thumbnailHeight,
                    dropzone.options.thumbnailMethod,
                    true,
                    (thumbnail) => {
                        dropzone.emit('thumbnail', file, thumbnail);
                    },
                    "Anonymous");
            }
            if (typeof index === "undefined") {
                let fileIndex =
                    existingFiles
                        .filter(e_file =>
                            file.fileId === e_file.fileId
                            || dropzone.files.findIndex(d_file =>
                                d_file.fileId === e_file.fileId) > 0)
                        .findIndex(f_file => f_file.fileId === file.fileId);
                if (fileIndex > -1) {
                    dropzone.files.splice(index, fileIndex, file);
                } else {
                    dropzone.files.push(file);
                }
            } else if (index > -1) {
                dropzone.files.splice(index, 0, file);
            }
            dropzone.emit("complete", file);
        };

        const addExistingFiles = (dropzone, files) =>
            files.forEach((file, index) => addFileToDropZone(dropzone, file, index));

        // Add existing files to the dropzone
        const existingFiles = $(element).data("existingFiles")
        addExistingFiles(this.myDropzone, existingFiles);
    }
}

Dropzone.autoDiscover = false;

Dropzone.confirm = function (question, accepted, rejected) {
    // Ask the question, and call accepted() or rejected() accordingly.
    // CAREFUL: rejected might not be defined. Do nothing in that case.
    if (confirm("Are you sure you want to remove this file?")) {
        accepted();
    } else {
        rejected();
    }
};

export default ActiveStorageDropzoneNew;

document.addEventListener("turbolinks:load", function () {
    $("[data-behavior=dropzone-new]").each(function (index, element) {
        const dropzone = new ActiveStorageDropzoneNew
        dropzone.init(element);
    });

    $("[data-behavior=trigger-photos-click]").click(function () {
        const target = $(this).data("target");
        $(target).trigger("click");
    });
});


